import { ActionType, CancellationType } from '@banking/ui/workflows/card-settings/cancel-card';
import { filter, map } from 'rxjs/operators';
import { EventLogging } from '@banking/ui/workflows/card-settings/analytics/analytics';
export let Target = /*#__PURE__*/function (Target) {
  Target["NeverReceivedCard"] = "Never Received Card";
  return Target;
}({});
const neverReceivedCardClick = updates => updates.pipe(filter(([_, action]) => action.type === ActionType.Initialize && action.cancellationType === CancellationType.AccountHolderNeverReceivedCard), map(([[_before, after], _]) => EventLogging.CDP.event({
  action: EventLogging.Action.Click,
  target: Target.NeverReceivedCard,
  unitToken: after.unitToken
})));
export default [neverReceivedCardClick];